module.exports = __webpack_public_path__ + "img/banner-referral.a673bcc4.webp";